<template>
  <div class="openingSteps tw-w-full tw-bg-white tw-py-24">
    <div
      class="tab-view-container medium-item tw-w-full tw-flex tw-flex-col"
      :class="{ 'animate-slide-up': isVisible }"
    >
      <p
        class="tw-text-4xl tw-text-textMain tw-font-semibold tw-text-center"
      >
        <!-- <span class="tw-text-primary"></span> -->
        <span>{{ $t("3步") }}{{ $t("开启您的区块链转型") }}</span>
      </p>
      <span class="tw-w-full tw-text-center tw-text-xs md:tw-text-sm tw-text-textDisabled tw-block tw-mb-16">
        {{ $t("从沟通方案确认到开发上线，提供高效、透明、可靠的区块链开发服务") }}
      </span>
      
      <div class="home-section-inner">
          <!-- 三个卡片容器 -->
          <div class="tw-flex tw-items-center tw-justify-center tw-gap-2">
            <!-- 循环渲染卡片和箭头 -->
            <template v-for="(item, index) in stepsList">
              <div
                :key="index"
                class="step-card tw-relative tw-flex"
                style="
                  background: #FFFFFF;
                  box-shadow: 0px 4px 40px 0px rgba(29,95,235,0.1);
                  border-radius: 20px;
                  padding: 30px;
                  flex: 1;
                  max-width: 420px;
                  min-height: 360px;
                "
              >
                <!-- 左侧文字内容 - 占60% -->
                <div 
                  class="tw-relative tw-z-10 tw-flex tw-flex-col"
                  style="width: 65%; padding-right: 10px;"
                >
                  <!-- 数字标签 -->
                  <div
                    class="tw-flex tw-items-center tw-justify-center tw-text-white tw-font-bold"
                    style="
                      width: 56px;
                      height: 40px;
                      background: linear-gradient(90deg, #4077F8 0%, #3D4BDF 100%);
                      border-radius: 100px;
                      font-size: 18px;
                    "
                  >
                    {{ String(index + 1).padStart(2, '0') }}
                  </div>

                  <!-- 主标题 -->
                  <h3
                    class="tw-font-semibold tw-mt-6"
                    style="
                      font-size: 22px;
                      color: #111111;
                    "
                  >
                    {{ $t(item.title) }}
                  </h3>

                  <!-- 小横线 -->
                  <div
                    style="
                      width: 35px;
                      height: 0;
                      border: 3px solid #4077F8;
                      margin-top: 12px;
                      margin-bottom: 16px;
                    "
                  ></div>

                  <!-- 详细介绍 -->
                  <p
                    class="tw-flex-1"
                    style="
                      font-weight: 500;
                      font-size: 14px;
                      color: #666666;
                      line-height: 1.8;
                    "
                  >
                    {{ $t(item.description) }}
                  </p>

                  <!-- 底部按钮 -->
                  <div class="tw-flex tw-gap-2 tw-mt-auto tw-flex-wrap">
                    <div
                      v-for="(btn, btnIndex) in item.buttons"
                      :key="btnIndex"
                      class="tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-transition-all hover:tw-shadow-md"
                      style="
                        width: 104px;
                        height: 32px;
                        background: #FFFFFF;
                        border-radius: 100px;
                        border: 1px solid #E9E9E9;
                        flex-shrink: 0;
                      "
                    >
                      <img
                        src="@/assets/home/right.png"
                        alt=""
                        class="tw-mr-0.5"
                        style="width: 16px; height: 16px;"
                      />
                      <span
                        style="
                          font-weight: 500;
                          font-size: 14px;
                          color: #4077F8;
                          white-space: nowrap;
                        "
                      >
                        {{ $t(btn) }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- 右侧背景图 - 占40%区域 -->
                <img
                  :src="item.bgImg"
                  alt=""
                  class="tw-absolute tw-bottom-0 tw-right-0"
                  style="
                    width: 45%;
                    max-width: 200px;
                  "
                />
              </div>

              <!-- 箭头分隔符（不在最后一个卡片后显示） -->
              <div
                v-if="index < stepsList.length - 1"
                :key="'arrow-' + index"
                class="tw-flex tw-items-center"
                style="color: #4077F8; flex-shrink: 0; padding: 0 2px;"
              >
                <img
                  src="@/assets/home/arrow_three.png"
                  alt=""
                  style="width: 32px; height: 32px;"
                />
              </div>
            </template>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import step01 from "@/assets/home/step01.png";
import step02 from "@/assets/home/step02.png";
import step03 from "@/assets/home/step03.png";

export default {
  name: "openingSteps",
  props: {},
  components: {},
  data() {
    return {
      isVisible: false,
      currentStep: 0,
      stepsList: [
        {
          bgImg: step01,
          title: "咨询对话",
          description: "深入沟通业务需求、应用场景与核心功能，明确项目方向，输出可落地的区块链解决方案。",
          buttons: ["需求梳理", "方案诊断"]
        },
        {
          bgImg: step02,
          title: "报价签约",
          description: "根据功能范围与开发周期透明报价，明确付款方式、交付节点与合同内容，合作清晰推进。",
          buttons: ["透明报价", "合同确认"]
        },
        {
          bgImg: step03,
          title: "项目实施",
          description: "组建项目团队，完成 UI 设计、功能开发、测试部署与上线交付，确保项目稳定落地。",
          buttons: ["开发实施", "上线交付"]
        },
      ],
      observer: null,
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0.1,
        },
      );

      this.observer.observe(this.$el);
    },
  },
};
</script>

<style lang="scss" scoped>
.openingSteps {
  background: #f9fafc;
}

.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}

.step-card {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 8px 50px 0px rgba(29,95,235,0.15);
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .openingSteps {
    padding: 40px 16px;
  }
  
  .step-card {
    width: 100% !important;
    max-width: 300px;
  }
}
</style>
